import { render } from "./AuthorHorizontalCard.vue?vue&type=template&id=ee3b11d6"
import script from "./AuthorHorizontalCard.vue?vue&type=script&lang=js"
export * from "./AuthorHorizontalCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/zaytoon-mtn-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__